export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	requestUserVerification() {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/user/request-verification')
				.then((res) => resolve(res))
				.catch((err) => reject(err));
		});
	},

	uploadUserDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/user/documents', payload)
				.then((res) => resolve(res))
				.catch((err) => reject(err));
		});
	},
};
